import { v4 as uuidv4 } from 'uuid';
import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';

export interface IOrdemServicoMaoDeObra {
  iditem: string;
  idos: string;
  mecanico: string;
  descricao: string;
  valor: number;
}

export interface ICreateOrdemServicoMaoDeObra {
  mecanico: string;
  descricao: string;
  valor: number;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

const tratarErro = (error: unknown): Error => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ErrorResponse>;
    if (axiosError.response) {
      return new Error(axiosError.response.data.errors?.default || 'Erro desconhecido');
    } else if (axiosError.request) {
      return new Error('Nenhuma resposta do servidor');
    } else {
      return new Error(axiosError.message);
    }
  }
  return new Error('Erro inesperado');
};

const create = async (idos: string, dados: ICreateOrdemServicoMaoDeObra): Promise<IOrdemServicoMaoDeObra | Error> => {
  try {
    const iditem = uuidv4();
    await Api.post(`/ordemservico/${idos}/maodeobra`, { iditem, ...dados });
    return { iditem, idos, ...dados };
  } catch (error) {
    return tratarErro(error);
  }
};

const updateById = async (idos: string, iditem: string, dados: ICreateOrdemServicoMaoDeObra): Promise<IOrdemServicoMaoDeObra | Error> => {
  try {
    await Api.put(`/ordemservico/${idos}/maodeobra/${iditem}`, dados);
    return { iditem, idos, ...dados };
  } catch (error) {
    return tratarErro(error);
  }
};

const deleteById = async (idos: string, iditem: string): Promise<void | Error> => {
  try {
    await Api.delete(`/ordemservico/${idos}/maodeobra/${iditem}`);
  } catch (error) {
    return tratarErro(error);
  }
};

export const OrdemServicoMaoDeObraService = {
  create,
  updateById,
  deleteById,
};
